import React from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwScreenshot = () => {
  const sections = [
    {
      heading: "Login Form Screenshot",
      ui: (
        <div className={styles.loginCard}>
          <h2>USERNAME</h2>
          <input placeholder="username" />

          <h2>PASSWORD</h2>
          <input type="password" placeholder="Password" />

          <button className={styles.primaryBtn}>sign in</button>
        </div>
      ),
      code: `// Full page screenshot
await page.screenshot({ path: 'login.png', fullPage: true });

// Element screenshot
await page.locator('button').screenshot({ path: 'button.png' });`
    }
  ];

  return <PlaywrightTemplate title="📸 Screenshot" sections={sections} />;
};

export default PwScreenshot;